export default __webpack_public_path__ + "static/media/lock.8212404c.svg";